import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard.service';
import {ReportService} from '../../services/report/report.service';

import { CompanyService } from '../../services/Company/company.service';
import { OthersService} from '../../services/others/others.service';


@Component({
  selector: 'app-top-performers',
  templateUrl: './top-performers.component.html',
  styleUrls: ['./top-performers.component.scss']
})
export class TopPerformersComponent implements OnInit {
  public topPerformers = [];
  currentCompany;
  constructor(private dashboardService: DashboardService,private companyService:CompanyService, private reportService:ReportService,
    private otherService:OthersService) {

    this.currentCompany = companyService.getCurrentCompany();


  
  }

  ngOnInit(): void {
    if (this.currentCompany) {
      let role_id = this.currentCompany.role_id;

          if (role_id == 1 || role_id == 2 || role_id == 4) {
          
              this.getStats();
          }
    }
    else {
      this.otherService.currentComp$.subscribe(res => {
        //console.log("TTTT123=== " + JSON.stringify(res));
        //this.staff = res;
        //this.fillForm();
        //alert("I am here too")
        if (res) {
          this.currentCompany = res;
          let role_id = this.currentCompany.role_id;

          if (role_id == 1 || role_id == 2 || role_id == 4) {
            this.getStats();
          }
          
        }
        
      });
    }
  }

  getStats() {
    this.reportService.getStats(this.currentCompany.id).then((res:any)=>{
        console.log("Top=" + JSON.stringify(res));
        if (res.status == 'OK') {
           //if (res.data)
            this.topPerformers= res.data;
        }
    })
}

}
